import styled from 'styled-components';
import {Typography as MuiTypography} from '@mui/material';

const Typography = styled(MuiTypography)`
  margin-top: 1rem;
`;
export default Typography;
